<template>
  <v-menu
    attach
    content-class="popover-menu-vuetify"
    min-width="263"
    right
    v-bind:close-on-click="false"
    v-bind:close-on-content-click="false"
    v-bind:left="flip"
    v-bind:offset-x="true"
    v-bind:top="top"
    v-bind:value="value"
  >
    <template v-slot:activator="{ on }">
      <slot
        name="trigger"
        v-bind:listener-object="on" />
    </template>
    <slot />
  </v-menu>
</template>
<script>
import { popoverMixin } from '@/mixins/builtInPopoverMixin';

/**
 * @description Компонент диалогового меню.
 * @type {Vue}
 */
export default {
  mixins: [
    popoverMixin,
  ],
  name: 'ToothPopoverMenu',
  props: {
    flip: { type: Boolean, default: false },
    top: { default: () => false, type: Boolean },
    value: Boolean,
  },
};
</script>
<style scoped>
.popover-menu-vuetify {
  overflow: hidden;
  background-color: var(--primary-background-color);
}
</style>
